import { fetchWithAuth } from '@shared/utils/auth';
import { backendUrl } from '@shared/constants/urls/appUrls';

//Топ гейнеры
export async function getTopGainers(limit = 6) {
  const url = `${backendUrl}/api/screener/signal-filter/top-gainers/?limit=${limit}`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка получения топ-гейнеров: HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка получения топ-гейнеров:', error);
    throw error;
  }
}